/**
 * Client custom JavaScript (bundled to assets/beef-custom.js).
 * Prefer small, focused modules; import them here.
 */

import { initMegaNav } from './mega-nav.js';
import { initTrustpilotFade } from './trustpilot-fade.js';
import { initUspRotate } from './usp-rotate.js';
import { initStickyTopBar } from './sticky-top-bar.js';
import { initJudgemeBadge } from './judgeme-badge.js';
import { initDeliveryUsp } from './delivery-usp.js';
import { initHeaderCtas } from './header-ctas.js';
import { initCartCount } from './cart-count.js';
import { initActiveFilters } from './active-filters.js';
import { initVariantScroll } from './variant-scroll.js';
import { initBlogTags } from './blog-tags.js';
import { initQuickshop } from './quickshop.js';
import { initHeroParallax } from './hero-parallax.js';

function init() {
  if (document.documentElement.classList.contains('js')) {
    initMegaNav();
    initTrustpilotFade();
    initUspRotate();
    initStickyTopBar();
    initJudgemeBadge();
    initDeliveryUsp();
    initHeaderCtas();
    initCartCount();
    initActiveFilters();
    initVariantScroll();
    initBlogTags();
    initQuickshop();
    initHeroParallax();
    // Hook theme readiness / DOM
    document.dispatchEvent(new CustomEvent('beef-custom:ready'));
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
